document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".wp-block-capmonetique-accordion-with-image-item")
    if (accordionItems.length === 0) return

    // Fonction pour déplacer les éléments selon la taille d'écran
    function rearrangeElements() {
        const isMobile = window.innerWidth < 1200

        accordionItems.forEach((item) => {
            const accordionTexts = item.querySelector(".accordion-texts")
            const accordionImage = item.querySelector(".accordion-image")
            const accordionHeader = item.querySelector(".accordion-header")
            const accordionContent = item.querySelector(".accordion-content")

            if (!accordionTexts || !accordionHeader) return

            if (isMobile) {
                // En dessous de 1200px : déplacer .accordion-texts et .accordion-image dans .accordion-content
                if (accordionTexts.parentElement !== accordionContent) {
                    // Marquer l'emplacement original pour pouvoir restaurer
                    if (!accordionTexts.dataset.originalParent) {
                        const parentElement = accordionTexts.parentElement
                        let parentClassName = "original-parent"
                        if (parentElement && parentElement.classList && parentElement.classList.length > 0) {
                            parentClassName = parentElement.classList[0]
                        }
                        accordionTexts.dataset.originalParent = parentClassName
                        accordionTexts.dataset.originalIndex = Array.from(parentElement.children).indexOf(accordionTexts)
                    }

                    // Déplacer vers le content
                    if (accordionContent) {
                        accordionContent.appendChild(accordionTexts)
                    }
                }

                if (accordionImage && accordionImage.parentElement !== accordionContent) {
                    // Marquer l'emplacement original pour pouvoir restaurer
                    if (!accordionImage.dataset.originalParent) {
                        const parentElement = accordionImage.parentElement
                        let parentClassName = "original-parent"
                        if (parentElement && parentElement.classList && parentElement.classList.length > 0) {
                            parentClassName = parentElement.classList[0]
                        }
                        accordionImage.dataset.originalParent = parentClassName
                        accordionImage.dataset.originalIndex = Array.from(parentElement.children).indexOf(accordionImage)
                    }

                    // Déplacer vers le content
                    if (accordionContent) {
                        accordionContent.appendChild(accordionImage)
                    }
                }
            } else {
                // Au-dessus de 1200px : restaurer la position originale
                if (accordionTexts.dataset.originalParent && accordionTexts.parentElement === accordionContent) {
                    // Trouver le conteneur original
                    let originalParent = item.querySelector(`.${accordionTexts.dataset.originalParent}`)
                    if (!originalParent && accordionTexts.dataset.originalParent === "original-parent") {
                        // Si pas trouvé par classe, chercher par structure
                        originalParent = item
                    }

                    if (originalParent && originalParent !== accordionContent) {
                        originalParent.appendChild(accordionTexts)
                    }

                    // Nettoyer les attributs de données
                    delete accordionTexts.dataset.originalParent
                    delete accordionTexts.dataset.originalIndex
                }

                if (accordionImage && accordionImage.dataset.originalParent && accordionImage.parentElement === accordionContent) {
                    // Trouver le conteneur original
                    let originalParent = item.querySelector(`.${accordionImage.dataset.originalParent}`)
                    if (!originalParent && accordionImage.dataset.originalParent === "original-parent") {
                        // Si pas trouvé par classe, chercher par structure
                        originalParent = item
                    }

                    if (originalParent && originalParent !== accordionContent) {
                        originalParent.appendChild(accordionImage)
                    }

                    // Nettoyer les attributs de données
                    delete accordionImage.dataset.originalParent
                    delete accordionImage.dataset.originalIndex
                }
            }
        })
    }

    // Exécuter au chargement
    rearrangeElements()

    // Écouter les changements de taille de fenêtre
    let resizeTimeout
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(rearrangeElements, 100)
    })

    // Observer les changements dans le DOM (au cas où des éléments sont ajoutés dynamiquement)
    const observer = new MutationObserver((mutations) => {
        let shouldRearrange = false
        mutations.forEach((mutation) => {
            if (
                mutation.type === "childList" &&
                (mutation.target.classList.contains("wp-block-capmonetique-accordion-with-image-item") ||
                    mutation.target.closest(".wp-block-capmonetique-accordion-with-image-item"))
            ) {
                shouldRearrange = true
            }
        })

        if (shouldRearrange) {
            setTimeout(rearrangeElements, 50)
        }
    })

    // Observer chaque item d'accordéon
    accordionItems.forEach((item) => {
        observer.observe(item, {
            childList: true,
            subtree: true,
        })
    })
})
